import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';    
import { IndexComponent } from './index/index.component';
import { LiveEventsSendComponent } from './live-events-send/live-events-send.component';
import { LiveEventsViewComponent } from './live-events-view/live-events-view.component';  
import { TariffTesterComponent } from './tariff-tester/tariff-tester.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { OccupancyComponent } from './occupancy/occupancy.component';
import { VideostreamingComponent } from './videostreaming/videostreaming.component';
import { ParkingStationsComponent } from './parking-stations/parking-stations.component';
import { BlackListWhiteListComponent } from './black-list-white-list/black-list-white-list.component';
import { ViewRechargeRenewSlipComponent } from './view-recharge-renew-slip/view-recharge-renew-slip.component';
import { ShiftSummaryComponent } from './shift-summary/shift-summary.component';
import { FastagReconciliationComponent } from './fastag-reconciliation/fastag-reconciliation.component';
import { TchgpwdComponent } from './tchgpwd/tchgpwd.component';
import { LogFileCnvrtCSVComponent } from './log-file-cnvrt-csv/log-file-cnvrt-csv.component';
import { ParkandflyComponent } from './Parkandfly/parkandfly.component';


const routes: Routes = [ //Site routes goes here 
  {
    path: 'index',
    component: MainLayoutComponent,
    children: [
      { path: '', component: IndexComponent, pathMatch: 'full' },
      { path: 'index', component: IndexComponent, pathMatch: 'full' }
      , { path: 'parkandfly', component: ParkandflyComponent, pathMatch: 'full' }
      , { path: 'liveview', component: LiveEventsViewComponent, pathMatch: 'full' }
      , { path: 'livesend', component: LiveEventsSendComponent, pathMatch: 'full' }
      , { path: 'tarifftester', component: TariffTesterComponent, pathMatch: 'full' }
      , { path: 'occupancy', component: OccupancyComponent, pathMatch: 'full' }
      , { path: 'videostreaming', component: VideostreamingComponent, pathMatch: 'full' }
      , { path: 'parking-stations', component: ParkingStationsComponent, pathMatch: 'full' }
      , { path: 'black-list-white-list', component: BlackListWhiteListComponent, pathMatch: 'full' }
      , { path: 'log-file-cnvrt-csv', component: LogFileCnvrtCSVComponent, pathMatch: 'full' }

    ]

  },
  { path: 'masters', loadChildren: () => import('./masters/masters.module').then(m => m.MastersModule) },
  { path: 'tariff', loadChildren: () => import('./rate/rate.module').then(m => m.RateModule) },
  { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
  { path: '', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'view-recharge-renew-slip', component: ViewRechargeRenewSlipComponent, pathMatch: 'full' },
  { path: 'shift-summary', component: ShiftSummaryComponent, pathMatch: 'full' },
  { path: 'fastag-reconciliation', component: FastagReconciliationComponent, pathMatch: 'full' },

  { path: 'tchgpwd',component:TchgpwdComponent, pathMatch:'full' },

  { path: '**', redirectTo: 'index', pathMatch: 'full' }

  //add temp password location
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
